import { FC, useEffect } from 'react';
import { Container } from '@material-ui/core';
import { useStyles } from './styles';
import { ViewEndUserForm } from 'components/Forms/UserForm/SubForms/ViewEndUseForm';

const ViewEndUserRegistration: FC = () => {
  const classes = useStyles();
  useEffect(() => {
    document.title = 'EasyIdentity: Review EndUser Registration';
  }, []);
  return (
    <Container maxWidth='xl' className={classes.container}>
      <div className={classes.formContainer}>
        <ViewEndUserForm selfRegister />
      </div>
    </Container>
  );
};

export default ViewEndUserRegistration;
